import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing, TextVariants } from '@lichtblick/theme';

export const SearchWrapper = styled.div`
  font-family: 'Roboto', sans-serif;
  position: relative;
`;

const BaseContainer = styled.div`
  align-items: center;
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xs};
  display: flex;
  gap: ${Spacing.Xs};
  height: ${Spacing.L};
  padding: 0rem ${Spacing.Xs};
  position: relative;
`;

export const SearchContainer = styled(BaseContainer)`
  background-color: ${Colors.white};
  border-color: ${Colors.blue[100]};
  box-shadow: -1rem 0 0.5rem ${Colors.white};
  color: ${Colors.black};
  width: 26.5rem;
`;

export const OptionsContainer = styled(BaseContainer)`
  align-items: flex-start;
  background-color: ${Colors.white};
  box-shadow: 0 0.25rem 0.5rem 0 rgba(16, 114, 186, 0.16);
  display: flex;
  flex-direction: column;
  height: auto;
  margin-top: ${Spacing.Xxs};
  padding: ${Spacing.Xs};
  position: absolute;
  width: 26.5rem;
  z-index: 2;
`;

export const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: ${Spacing.Xxs};
`;

export const Spacer = styled.hr`
  border: 1px solid ${Colors.blue[20]};
  margin: ${Spacing.S} 0;
  padding: 0;
  width: 100%;
`;

export const Input = styled.input`
  border: none;
  outline: transparent;
  width: 100%;
  ${TextVariants.button.m}

  &::placeholder {
    ${TextVariants.button.m}
    color: ${Colors.gray[100]};
  }
`;
